module.exports = __webpack_public_path__ + "static/meg-pic-ba16155c902b33a7aea76c6dc9448b9e.png";